<template>
    <router-view></router-view>
</template>

<script>
export default {
name: "Medical"
}
</script>

<style scoped>

</style>